var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestingServiceSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8361_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 15.75V5.0625L10.4375 0H4.25C3.00736 0 2 1.00736 2 2.25V15.75C2 16.9926 3.00736 18 4.25 18H13.25C14.4926 18 15.5 16.9926 15.5 15.75ZM10.4375 3.375C10.4375 4.30698 11.193 5.0625 12.125 5.0625H14.375V10.125H3.125V2.25C3.125 1.62868 3.62868 1.125 4.25 1.125H10.4375V3.375ZM3.125 13.5V11.25H5.375V13.5H3.125ZM3.125 14.625H5.375V16.875H4.25C3.62868 16.875 3.125 16.3713 3.125 15.75V14.625ZM6.5 16.875V14.625H14.375V15.75C14.375 16.3713 13.8713 16.875 13.25 16.875H6.5ZM14.375 13.5H6.5V11.25H14.375V13.5Z",
    fill: "#5C5E69"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8361_3312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.8531,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingServiceSvg);
export default __webpack_public_path__ + "static/media/testing-service-svg.025d8760c46ff6ad061093f502f3e50b.svg";
export { ForwardRef as ReactComponent };